import querystring from 'querystring';
import query from '../node_modules/@zillow/parsed-query/dist/parsed-query.esm.js';

var getHashParams = function getHashParams() {
  var hashparams = {};

  if (typeof window !== 'undefined' && window.location && window.location.hash) {
    var trimmedHash = window.location.hash && decodeURIComponent(window.location.hash.replace(/[#/*]/g, ''));
    hashparams = querystring.parse(trimmedHash);
  }

  return hashparams;
};

var PLATFORM_QUERY = 'appPlatform'; // One of ['android', 'ios']
// Might use device class later
// const DEVICE_CLASS_QUERY = 'appDeviceClass'; // One of ['tablet', 'phone']

var getPlatform = function getPlatform() {
  var platform = typeof window !== 'undefined' && window.ZMOB_data && typeof window.ZMOB_data.getAppPlatform === 'function' && window.ZMOB_data.getAppPlatform();
  return platform || query[PLATFORM_QUERY] || getHashParams()[PLATFORM_QUERY];
}; // export const getDeviceClass = () => query[DEVICE_CLASS_QUERY];

var isWebview = function isWebview() {
  return !!getPlatform();
};

export { getPlatform, isWebview };
//# sourceMappingURL=mortgage-webview-query-params.esm.js.map
